import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { TransactionTable } from "@/components/transactions/TransactionTable";
import { TransactionFilters } from "@/components/transactions/TransactionFilters";
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const TransactionMonitoring = () => {
  const [transactionType, setTransactionType] = useState("all");
  const [dateRange, setDateRange] = useState("all");

  const { data: transactions, isLoading } = useQuery({
    queryKey: ['admin-transactions', transactionType, dateRange],
    queryFn: async () => {
      let query = supabase
        .from('account_transactions')
        .select('*')
        .order('created_at', { ascending: false });

      if (transactionType !== 'all') {
        query = query.eq('transaction_type', transactionType);
      }

      if (dateRange !== 'all') {
        const now = new Date();
        let startDate = new Date();
        
        switch (dateRange) {
          case '7days':
            startDate.setDate(now.getDate() - 7);
            break;
          case '30days':
            startDate.setDate(now.getDate() - 30);
            break;
          case '90days':
            startDate.setDate(now.getDate() - 90);
            break;
        }

        query = query.gte('created_at', startDate.toISOString());
      }

      const { data, error } = await query;
      if (error) throw error;
      return data;
    },
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle>Transaction Monitoring</CardTitle>
        <CardDescription>Monitor and analyze all financial transactions</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <TransactionFilters
            transactionType={transactionType}
            setTransactionType={setTransactionType}
            dateRange={dateRange}
            setDateRange={setDateRange}
          />
          <TransactionTable
            transactions={transactions || []}
            isLoading={isLoading}
          />
        </div>
      </CardContent>
    </Card>
  );
};